import { useState, useEffect } from "react";
import {
    Typography,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Grid,
    TextField,
    Card,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Tooltip,
    Backdrop,
    CircularProgress,
    Checkbox,
    Box,
    Chip,
    ListItemText,
    Autocomplete,
    OutlinedInput,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from "@mui/material";
import { cardHeader, buttonStyle, cardStyle, textStyle, headerStyle, subHeaderStyle, card_icon } from "../../styles/sharedStyles";
import { BarGraph, ScatterPlot, LineChart, MultiLineChart, ScatterPlotWithoutData, ErrorHistogram } from "../../utils/Graph";
import { fetchAPI } from "../../utils/ApiService";
import PerformancePlot from "../../utils/PerformancePlot";
import { CustomizedSnackbar } from "../../utils/CustomizedSnackbar";
import Plot from 'react-plotly.js';
import AirIcon from '@mui/icons-material/Air';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AllOutIcon from '@mui/icons-material/AllOut';
import ArticleIcon from '@mui/icons-material/Article';
import CycloneIcon from '@mui/icons-material/Cyclone';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import ModelGenerationProgressModal from "../../utils/ModelGenerationProgressModal";

export const SurrogateGeneration = () => {
    const [problemFormulationList, setProblemFormulationList] = useState([]);

    const [loadopen, setLoadpen] = useState(false);


    const preKernelList = [
        "0: Polynomial (degree=3)",
        "1: Polynomial (degree=4)",
        "2: RBF + Constant",
        "3: RBF + Linear",
        "4: RBF + Quadratic",
        "5: Matern (0.5) + Constant",
        "6: Matern (0.5) + Linear",
        "7: Matern (0.5) + Quadratic",
        "8: Matern (1.5) + Constant",
        "9: Matern (1.5) + Linear",
        "10: Matern (1.5) + Quadratic",
        "11: Matern (2.5) + Constant",
        "12: Matern (2.5) + Linear",
        "13: Matern (2.5) + Quadratic",
        "14: RationalQuadratic + Constant",
        "15: RationalQuadratic + Linear",
        "16: RationalQuadratic + Quadratic",
        "17: Probabilistic Neural Network"
    ];
    const [problemFormulation, setProblemFormulation] = useState("");
    const [geometryInputs, setGeometryInputs] = useState([]);
    const [boundaryCondition, setBoundaryCondition] = useState("");
    const [outputVariables, setoutputVariables] = useState([]);
    const [selectoutputVariable, setSelectoutputVariable] = useState("");
    const [selectKernel, setSelectKernel] = useState([]);
    const [errorMetric, setErrorMetric] = useState("");
    const errorMetricList = ['MAPE', "RMSE", "R2"];
    const [kernelList, setKernelList] = useState([]);
    const [surrogateModelName, setSurrogateModelName] = useState("");
    const [uniqueName, setUniqueName] = useState("");
    const [errorTable, setErrorTable] = useState([]);
    const [bestKernel, setBestKernel] = useState('');
    const [bestKernelName, setBestKernelName] = useState('');
    const [graph1, setGraph1] = useState({});
    const [graph2, setGraph2] = useState({});
    const [graph3, setGraph3] = useState({});
    const [graph4, setGraph4] = useState({});
    const [performancePlot1, setperformancePlot1] = useState({});
    const [performancePlot2, setperformancePlot2] = useState({});
    const [refDFTrain, setRefDFTrain] = useState(null);
    const [resDFTest, setResDFTest] = useState(null);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [severityType, setSeverityType] = useState("");
    const [inputConstraints, setInputConstraints] = useState('');
    const [outputConstraints, setOutputConstraints] = useState('');
    const [geometry, setGeometry] = useState(true);
    const [bestAlpha, setBestAlpha] = useState(null);
    const [trainingGeometries, setTrainingGeometries] = useState([]);
    const [testGeometries, setTestGeometries] = useState([]);
    const [testMape, setTestMape] = useState(null);
    const [testR2, setTestR2] = useState(null);
    const [finalTrialCompleted, setFinalTrialCompleted] = useState(false);
    const [surrogateNumber, setSurrogateNumber] = useState('');
    const [targetModels, setTargetModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState("");
    const [openInfoAlert, setopenInfoAlert] = useState(false);
    const [dataSetLength, setDataSetLength] = useState(0);
    const [progressBarValue, setProgressBarValue] = useState(0);
    const [progressBarMsg, setProgressBarMsg] = useState("");
    const [progressBarStatus, setProgressBarStatus] = useState("");


    const handleModelChange = (event) => setSelectedModel(event.target.value);

    const closeDialog = () => {
        setopenInfoAlert(false);
    };

    useEffect(()=> {
        setSelectKernel([]);
        if(dataSetLength >= 2000){
            setKernelList(["17: Probabilistic Neural Network"])
        }
        else{
            setKernelList(preKernelList)
        }

    }, [dataSetLength]);

    const getProblemList = async () => {
        try {
            setLoadpen(true)
            const token = localStorage.getItem("msal.idtoken");
            const { data: { data: problemList } } = await fetchAPI.get("/get_problem_formulation_list", {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            setProblemFormulationList(problemList);
            setLoadpen(false)
        } catch (error) {
            setLoadpen(false)
            console.error("Failed to fetch problem list:", error);
        }
    };


    const getMetaData = async (problemName) => {
        setLoadpen(true);

        try {
            const token = localStorage.getItem("msal.idtoken");

            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };
            const [problemRes, modalRes] = await Promise.all([
                fetchAPI.post("/get_meta_data", { problemName }, { headers }),
                fetchAPI.post("/get_models_list", { problemName }, { headers }),
            ]);

            setTargetModels(modalRes?.data?.data);

            setGeometryInputs(problemRes?.data?.data?.inputs || []);
            setBoundaryCondition(problemRes?.data?.data?.loaded_boundary || []);
            setoutputVariables(problemRes?.data?.data?.output_variables || []);
            setInputConstraints(JSON.stringify(problemRes?.data?.data?.constraints?.input) || "[ ]");
            setOutputConstraints(JSON.stringify(problemRes?.data?.data?.constraints?.output) || "[ ]");
            setDataSetLength(problemRes?.data?.data?.dataset_length || 0);
        } catch (error) {
            console.error("Failed to fetch metadata:", error);
        } finally {
            setLoadpen(false);
        }
    };

    const generateSurrogateParallel123 = async () => {

        try {

            const payload = {
                problemFormulation,
                geometryInputs: "['" + geometryInputs.join("','") + "']",
                boundaryCondition,
                selectoutputVariable,
                selectKernel,
                errorMetric: selectKernel.length <= 1 ? "MAPE" : errorMetric,
                surrogateModelName,
                uniqueName,
                geometry
            }

            const token = localStorage.getItem("msal.idtoken");

            const { data } = await fetchAPI.post(
                "/start_generate_surrogate",
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log(data)



        } catch (error) {
            console.error("Error: ", error);
        }

    }

    const generateSurrogateParallelTest = async () => {

        try {

            const payload = {
                problemFormulation,
                geometryInputs: "['" + geometryInputs.join("','") + "']",
                boundaryCondition,
                selectoutputVariable,
                selectKernel,
                errorMetric: selectKernel.length <= 1 ? "MAPE" : errorMetric,
                surrogateModelName,
                uniqueName,
                geometry
            }

            const token = localStorage.getItem("msal.idtoken");

            const { data } = await fetchAPI.post(
                "/generate_surrogate",
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log(data)



        } catch (error) {
            console.error("Error: ", error);
        }

    }





    const generateSurrogateParallel = async (payload) => {
        setLoadpen(true);
        setSnackbarOpen(false);
        setFinalTrialCompleted(false)
        setProgressBarStatus("IN_PROGRESS")
        setProgressBarValue(10)
        setProgressBarMsg("Getting started… Initializing the process.")

        try {
            const token = localStorage.getItem("msal.idtoken");

            const payload = {
                problemFormulation,
                geometryInputs: "['" + geometryInputs.join("','") + "']",
                boundaryCondition,
                selectoutputVariable,
                selectKernel,
                errorMetric: selectKernel.length <= 1 ? "MAPE" : errorMetric,
                surrogateModelName,
                uniqueName,
                geometry
            }

            console.log('payload :>> ', payload);



            const response = await fetchAPI.post(
                "/start_generate_surrogate",
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            if (response.status === 202 || response.status === 200) {
                console.log('response :>> ', response);

                const checkUploadStatus = async () => {

                    try {
                        const statusResponseURL = await fetchAPI.post("/upload_stats_surrogate", { problemFormulation, uniqueName, selectoutputVariable }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponseURL.status === 200) {
                            setProgressBarValue(90)
                            setProgressBarMsg("Done! Creating performance charts and final outputs.")

                            // 1️⃣ Get the pre-signed URL from backend
                            const presignedUrl = statusResponseURL.data.url;

                            // 2️⃣ Download JSON file directly from S3
                            const s3Response = await fetch(presignedUrl);

                            if (!s3Response.ok) {
                                setSnackbarMsg("Failed to download data from S3");
                                setSeverityType("error");
                                setSnackbarOpen(true);
                                return;
                            }

                            // 3️⃣ Parse JSON data
                            const statusResponse = await s3Response.json();



                            if (statusResponse?.data?.data?.error) {
                                setSnackbarMsg(statusResponse.data.data.message)
                                setSeverityType("warning")
                                setProgressBarStatus("FAILED")




                            } else {

                                setErrorTable(statusResponse.error_table ?? []);
                                setBestKernel(statusResponse.kernel ?? null);
                                setBestKernelName(statusResponse.kernel_name ?? null);
                                setGraph1(statusResponse.plot1 ?? null);
                                setGraph2(statusResponse.plot2 ?? null);
                                setGraph3(statusResponse.plot3 ?? null);
                                setGraph4(statusResponse.plot4 ?? null);
                                setperformancePlot1(statusResponse.performance_plot1 ?? null);
                                setperformancePlot2(statusResponse.performance_plot2 ?? null);
                                setRefDFTrain(statusResponse.res_df_train ?? null);
                                setResDFTest(statusResponse.res_df_test ?? null);
                                // setRefDFTrain(response.data?.res_df_train ?? null);
                                // setResDFTest(response.data?.res_df_test ?? null);
                                setBestAlpha(statusResponse.best_alpha ?? null);
                                setTrainingGeometries(statusResponse.training_geometries ?? []);
                                setTestGeometries(statusResponse.test_geometries ?? []);
                                setTestMape(statusResponse.error_table[1]["MAPE (%)"] ?? null);
                                setTestR2(statusResponse.error_table[1]["R2"] ?? null);

                                setLoadpen(false)
                                setSnackbarMsg("Surrogate generated successfully..")
                                setSeverityType("success")


                            }

                            setLoadpen(false)
                            setSnackbarOpen(true)
                            
                            setProgressBarStatus("COMPLETED")
                            

                        }
                        else {
                            console.log('Waiting for upload status to complete...',statusResponseURL.data.metadata?.message);
                            setTimeout(checkUploadStatus, 5000);
                            setProgressBarMsg(statusResponseURL.data?.metadata?.message ?? "Getting started… Initializing the process.")
                            setProgressBarStatus(statusResponseURL.data?.metadata?.status ?? "IN_PROGRESS")
                            setProgressBarValue(statusResponseURL.data?.metadata?.progress ?? 10)
                        }

                    } catch (error) {

                        const errorMessage = error.response?.data?.message || 'Error while generating surrogate model';
                        console.error(errorMessage);
                        setLoadpen(false);
                        setSnackbarMsg(errorMessage);
                        setSeverityType("error");
                        setSnackbarOpen(true);
                        setProgressBarStatus("FAILED")

                    }

                };
                checkUploadStatus();

            } else {
                setLoadpen(false)
                setProgressBarStatus("FAILED")
                throw new Error('Error storing the result to s3');
                // setTimeout(checkUploadStatus, 2000);
            }


        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'Error while generating surrogate model';
            console.error(errorMessage);
            setLoadpen(false)
            setSnackbarMsg(errorMessage)
            setSeverityType("error")
            setProgressBarStatus("FAILED")
            setSnackbarOpen(true)
        } finally {
            // setLoadpen(false);
        }
    };





    const generateSurrogate = async (payload) => {
        setLoadpen(true);
        setSnackbarOpen(false);
        setFinalTrialCompleted(false)

        try {
            const token = localStorage.getItem("msal.idtoken");

            const payload = {
                problemFormulation,
                geometryInputs: "['" + geometryInputs.join("','") + "']",
                boundaryCondition,
                selectoutputVariable,
                selectKernel,
                errorMetric: selectKernel.length <= 1 ? "MAPE" : errorMetric,
                surrogateModelName,
                uniqueName,
                geometry
            }

            console.log('payload :>> ', payload);



            const response = await fetchAPI.post(
                "/generate_surrogate1",
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // if (response.status === 202 || response.status === 200) {

            //     setErrorTable(response.data?.error_table ?? []);
            //     setBestKernel(response.data?.kernel ?? null);
            //     setGraph1(response.data?.plot1 ?? null);
            //     setGraph2(response.data?.plot2 ?? null);
            //     setGraph3(response.data?.plot3 ?? null);
            //     setGraph4(response.data?.plot4 ?? null);
            //     setperformancePlot1(response.data?.performance_plot1 ?? null);
            //     setperformancePlot2(response.data?.performance_plot2 ?? null);
            //     setRefDFTrain(response.data?.res_df_train ?? null);
            //     setResDFTest(response.data?.res_df_test ?? null);
            //     setBestAlpha(response.data?.best_alpha ?? null);
            //     setTrainingGeometries(response.data?.training_geometries ?? []);
            //     setTestGeometries(response.data?.test_geometries ?? []);
            //     setTestMape(response.data?.error_table[1]["MAPE (%)"] ?? null);
            //     setTestR2(response.data?.error_table[1]["R2"] ?? null);



            //     setLoadpen(false);
            //     setSnackbarMsg("Surrogate generated successfully..");
            //     setSeverityType("success");
            //     setSnackbarOpen(true);

            // }


            if (response.status === 202 || response.status === 200) {
                console.log('response :>> ', response);

                const checkUploadStatus = async () => {

                    try {
                        const statusResponse = await fetchAPI.post("/upload_stats_surrogate", { problemFormulation, uniqueName, selectoutputVariable }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponse.status === 200) {

                            if (statusResponse?.data?.data?.error) {
                                setSnackbarMsg(statusResponse.data.data.message)
                                setSeverityType("warning")


                            } else {

                                setErrorTable(statusResponse.data.data?.error_table ?? []);
                                setBestKernel(statusResponse.data.data?.kernel ?? null);
                                setGraph1(statusResponse.data.data?.plot1 ?? null);
                                setGraph2(statusResponse.data.data?.plot2 ?? null);
                                setGraph3(statusResponse.data.data?.plot3 ?? null);
                                setGraph4(statusResponse.data.data?.plot4 ?? null);
                                setperformancePlot1(statusResponse.data.data?.performance_plot1 ?? null);
                                setperformancePlot2(statusResponse.data.data?.performance_plot2 ?? null);
                                setRefDFTrain(statusResponse.data.data?.res_df_train ?? null);
                                setResDFTest(statusResponse.data.data?.res_df_test ?? null);
                                // setRefDFTrain(response.data?.res_df_train ?? null);
                                // setResDFTest(response.data?.res_df_test ?? null);
                                setBestAlpha(statusResponse.data.data?.best_alpha ?? null);
                                setTrainingGeometries(statusResponse.data.data?.training_geometries ?? []);
                                setTestGeometries(statusResponse.data.data?.test_geometries ?? []);
                                setTestMape(statusResponse.data.data?.error_table[1]["MAPE (%)"] ?? null);
                                setTestR2(statusResponse.data.data?.error_table[1]["R2"] ?? null);

                                setLoadpen(false)
                                setSnackbarMsg("Surrogate generated successfully..")
                                setSeverityType("success")


                            }

                            setLoadpen(false)
                            setSnackbarOpen(true)

                        }
                        else {
                            console.log('Waiting for upload status to complete...');
                            setTimeout(checkUploadStatus, 5000);
                        }

                    } catch (error) {

                        const errorMessage = error.response?.data?.message || 'Error while generating surrogate model';
                        console.error(errorMessage);
                        setLoadpen(false);
                        setSnackbarMsg(errorMessage);
                        setSeverityType("error");
                        setSnackbarOpen(true);

                    }

                };
                checkUploadStatus();

            } else {
                setLoadpen(false)
                throw new Error('Error storing the result to s3');
                // setTimeout(checkUploadStatus, 2000);
            }


        } catch (error) {
            const errorMessage = error.response.data.message || 'Error while generating surrogate model';
            console.error(errorMessage);
            setLoadpen(false)
            setSnackbarMsg(errorMessage)
            setSeverityType("error")
            setSnackbarOpen(true)
        } finally {
            // setLoadpen(false);
        }
    };

    const handleProblemFormulationChange = (event, newValue) => {
        console.log(`Checking if new value is okay ${newValue} ${event}`)
        if (newValue == null) {
        }
        else {
            setProblemFormulation(newValue)
            setSurrogateModelName('')
            setUniqueName(`${newValue}_`)
            getMetaData(newValue)
        }
    };

    const downloadSurrogateFile = async () => {
        setLoadpen(true);
        try {
            const payload = {
                problemName: uniqueName,
                outputVar: selectoutputVariable,
                // trainDf: refDFTrain,
                // testDf: resDFTest,
                selectedInputs: "['" + geometryInputs.join("','") + "']"
            };

            const token = localStorage.getItem("msal.idtoken");

            const { data } = await fetchAPI.post(
                "/download_surrogate_excel_file",
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log('response :>> ', data?.excel_path);
            const fileUrl = data?.excel_path;
            const link = document.createElement("a");
            link.href = fileUrl;
            // link.download = "results.xlsx";
            link.setAttribute('download', 'report.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error downloading file:", error);
            setSnackbarMsg("Unalbe to dowload the file")
            setSeverityType("error")
            setSnackbarOpen(true)
        }
        finally {
            setLoadpen(false)
        }
    };


    const trainFinalSurrogateModel = async () => {
        setLoadpen(true);
        setSnackbarOpen(false);
        setFinalTrialCompleted(false)

        try {
            const payload = {
                problemName: uniqueName,
                outputVar: selectoutputVariable,
                errorTable: errorTable,
                bestKernel: bestKernel,
                loadedBoundary: boundaryCondition,
                loadedInputs: "['" + geometryInputs.join("','") + "']",
                inputConstraints: inputConstraints === "[ ]" ? [] : JSON.parse(inputConstraints),
                outputConstraints: outputConstraints === "[ ]" ? [] : JSON.parse(outputConstraints),
                bestAlpha: bestAlpha
            };

            const token = localStorage.getItem("msal.idtoken");

            // const response = await fetchAPI.post(
            //     "/train_final_surrogate_model",
            //     payload,
            //     {
            //         headers: {
            //             'Content-Type': 'application/json',
            //             Authorization: `Bearer ${token}`,
            //         },
            //     }
            // );


            const response = await fetchAPI.post(
                "/start_train_final_surrogate_model",
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 202 || response.status === 200) {

                const checkUploadStatus = async () => {

                    try {
                        const statusResponse = await fetchAPI.post("/get_final_trial_status", { problemFormulation, uniqueName, selectoutputVariable }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponse.status === 200) {
                            if (statusResponse?.data?.data?.error) {
                                console.log(statusResponse.data.data.message)
                                setSnackbarMsg(statusResponse.data.data.message)
                                setSeverityType("warning")


                            } else {

                                setSnackbarMsg("Final trial completed successfully")
                                setSeverityType("success")
                                const token = localStorage.getItem("msal.idtoken");
                                const headers = {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token}`,
                                };
                                const [modalRes] = await Promise.all([
                                    fetchAPI.post("/get_models_list", { "problemName": problemFormulation }, { headers }),
                                ]);
                                setTargetModels(modalRes?.data?.data);
                                setFinalTrialCompleted(true);

                            }
                            setLoadpen(false)
                            setSnackbarOpen(true)



                        }
                        else {
                            console.log('Waiting for upload status to complete...');
                            setTimeout(checkUploadStatus, 5000);
                        }

                    } catch (error) {
                        const errorMessage = error.response.data.message || 'Error while doing the final trial of surrogate model';
                        console.error(errorMessage);
                        setLoadpen(false)
                        setSnackbarMsg(errorMessage)
                        setSeverityType("error")
                        setSnackbarOpen(true)

                    }

                };
                checkUploadStatus();

            } else {
                setLoadpen(false)
                setSnackbarMsg('Error while doing the final trial of surrogate model')
                setSnackbarOpen(true)
                throw new Error('Error while doing the final trial of surrogate model');
                // setTimeout(checkUploadStatus, 2000);
            }

            console.log('data :>> ')
        } catch (error) {
            const errorMessage = error.response.data.message || 'Error while doing the final trial of surrogate model';
            console.error(errorMessage);
            setLoadpen(false)
            setSnackbarMsg(errorMessage)
            setSeverityType("error")
            setSnackbarOpen(true)
        }

    };


    // const checkSurrogateButton =
    //     problemFormulation &&
    //     geometryInputs.length > 0 &&
    //     boundaryCondition &&
    //     selectoutputVariable &&
    //     surrogateModelName &&
    //     outputVariables.length > 0 &&
    //     (
    //         selectKernel.length ||
    //         (selectKernel.length < 1 && errorMetric)
    //     );

    const checkSurrogateButton =
        problemFormulation &&
        geometryInputs.length > 0 &&
        boundaryCondition &&
        selectoutputVariable &&
        surrogateModelName &&
        outputVariables.length > 0 &&
        (
            (selectKernel.length === 1) ||
            (selectKernel.length > 1 && errorMetric)
        );


    const ModelRecommendations = ({ test_mape, test_r2 }) => {
        const getMAPEFeedback = () => {
            if (test_mape == null) return null;

            if (test_mape > 15) {
                return (
                    <li style={{ color: '#d9534f' }}>
                        <b>⚠️ High error detected</b> (MAPE: {test_mape.toFixed(2)}%)
                    </li>
                );
            } else if (test_mape > 10) {
                return (
                    <li style={{ color: '#f0ad4e' }}>
                        <b>⚠️ Moderate error detected</b> (MAPE: {test_mape.toFixed(2)}%)
                    </li>
                );
            } else {
                return (
                    <li style={{ color: '#5cb85c' }}>
                        <b>✅ Good accuracy achieved</b> (MAPE: {test_mape.toFixed(2)}%)
                    </li>
                );
            }
        };

        const getR2Feedback = () => {
            if (test_r2 == null) return null;

            if (test_r2 < 0.7) {
                return (
                    <li style={{ color: '#d9534f' }}>
                        <b>⚠️ R² score below 0.7</b> ({test_r2.toFixed(3)}) indicates room for improvement
                    </li>
                );
            } else if (test_r2 < 0.9) {
                return (
                    <li style={{ color: '#f0ad4e' }}>
                        <b>✅ R² score is good</b> ({test_r2.toFixed(3)}) but could be improved further
                    </li>
                );
            } else {
                return (
                    <li style={{ color: '#5cb85c' }}>
                        <b>🌟 Excellent R² score</b> ({test_r2.toFixed(3)})
                    </li>
                );
            }
        };

        return (
            <div style={{ backgroundColor: '#f8f9fa', padding: 15, borderRadius: 8, borderLeft: '5px solid #2976d2' }}>
                <h3 style={{ color: '#2976d2', marginTop: 0 }}>📊 Model Performance Analysis & Recommendations</h3>

                <div style={{ marginTop: 15 }}>
                    <h4 style={{ color: '#333' }}>🔍 Performance Assessment:</h4>
                    <ul>
                        {getMAPEFeedback()}
                        {getR2Feedback()}
                    </ul>
                </div>

                <details style={{ marginTop: 15, border: '1px solid #ddd', borderRadius: 4, padding: 8 }}>
                    <summary style={{ cursor: 'pointer', color: '#2976d2', fontWeight: 'bold', padding: 5 }}>
                        🔧 Click to view improvement recommendations
                    </summary>
                    <div style={{ padding: 10, backgroundColor: '#fff', borderTop: '1px solid #eee', marginTop: 5 }}>
                        <ul>
                            <li>Try different kernel combinations</li>
                            <li>Add more simulation points in regions where error is higher</li>
                            <li>Check for outliers in your data</li>
                            <li>Consider if all input variables are relevant or if some could be removed</li>
                            <li>Explore different preprocessing techniques for your data (e.g., polynomial features)</li>
                            <li>Use an error metric aligned with your application</li>
                        </ul>
                    </div>
                </details>
            </div>
        );
    };

    useEffect(() => {
        getProblemList();
    }, []);

    const generate_adaptive_sampling = async () => {
        setLoadpen(true);
        setSnackbarOpen(false);

        try {

            let payload = {
                problemName: problemFormulation,
                outputVar: selectoutputVariable,
                loadedBoundary: boundaryCondition,
                loadedInputs: "['" + geometryInputs.join("','") + "']",
                sampleNumber: surrogateNumber,
                selectedModel: selectedModel
            };

            if (bestKernel) {
                payload = {
                    ...payload,
                    errorTable: errorTable,
                    bestKernel: bestKernel,
                    bestAlpha: bestAlpha,
                    inputConstraints: inputConstraints === "[ ]" ? [] : JSON.parse(inputConstraints),
                    outputConstraints: outputConstraints === "[ ]" ? [] : JSON.parse(outputConstraints),
                }
            }

            const token = localStorage.getItem("msal.idtoken");

            const response = await fetchAPI.post(
                "/generate_adaptive_sample",
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log(response)

            if (response.status === 202 || response.status === 200) {
                console.log('response :>> ', response);

                const checkUploadStatus = async () => {

                    try {
                        const statusResponse = await fetchAPI.post("/sample_stats", { problemFormulation, selectedModel, surrogateNumber }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponse.status === 200) {

                            if (statusResponse?.data?.data?.error) {
                                setSnackbarMsg(statusResponse.data.data.message)
                                setSeverityType("warning")


                            } else {

                                console.log("response")
                                console.log(statusResponse?.data?.data)
                                console.log("response")


                                window.location.assign(statusResponse?.data?.data);

                                setSnackbarMsg("Samples generated successfully..")
                                setSeverityType("success")
                                // setLoadpen(false)


                            }

                            setLoadpen(false)
                            setSnackbarOpen(true)

                        }
                        else {
                            console.log('Waiting for upload status to complete...');
                            setTimeout(checkUploadStatus, 5000);
                        }

                    } catch (error) {

                        const errorMessage = error.response?.data?.message || 'Error while generating surrogate model';
                        console.error(errorMessage);
                        setLoadpen(false);
                        setSnackbarMsg(errorMessage);
                        setSeverityType("error");
                        setSnackbarOpen(true);

                    }

                };
                checkUploadStatus();

            } else {
                setLoadpen(false)
                throw new Error('Error while generating the adaptive sampling csv file');
                // setTimeout(checkUploadStatus, 2000);
            }

        }
        catch (error) {
            const errorMessage = error.response.data.message || 'Error while generating the adaptive sampling.';
            console.error(errorMessage);
            setLoadpen(false)
            setSnackbarMsg(errorMessage)
            setSeverityType("error")
            setSnackbarOpen(true)
        }



    }


    const cardStyle = {
        marginTop: "12px",
        padding: "20px",
        borderRadius: "20px",
        border: "0px",
    }

    const buttonStyle = {
        padding: "6px 24px",
        borderRadius: "8px",
        fontSize: "large",
        fontWeight: "bold",
        backgroundColor: "#2a2aa8"
    }

    const renderValue = (selected) => {
        if (selected.length === 0) return <Chip label="None Selected" />;
        if (selected.length <= 2) {
            return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                        <Chip color="primary" key={value} label={value} />
                    ))}
                </Box>
            );
        }

        // Show single Chip with count, and tooltip on hover for full list
        return (
            <Tooltip title={selected.join(', ')} arrow>
                <Chip color="primary" label={`${selected.length} selected`} />
            </Tooltip>
        );
    };

    return (
        <>
            <Typography
                variant="h5"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "rgb(27 37 75)",
                    fontFamily: "DM Sans, sans-serif",
                    fontSize: "24px",
                }}
            >
                Generate surrogate
            </Typography>

            <Card variant="outlined" sx={cardStyle}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={[cardHeader, { marginBottom: "0px", }]}>Select a problem formulation</Typography>
                </Grid>
                <Grid container spacing={4} sx={{ mb: 3 }}>
                    <Grid size={12}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <Autocomplete
                                id="problem-formulation-autocomplete"
                                options={problemFormulationList || []}
                                value={problemFormulation || null}
                                onChange={handleProblemFormulationChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select problem formulation"
                                        variant="outlined"
                                        placeholder="Search problem formulation"
                                    />
                                )}
                                filterOptions={(options, { inputValue }) => {
                                    return options.filter(option =>
                                        option.toLowerCase().includes(inputValue.toLowerCase())
                                    );
                                }}
                                isOptionEqualToValue={(option, value) => option === value}
                                clearOnEscape
                                selectOnFocus
                                handleHomeEndKeys
                            />
                        </FormControl>
                        {/* <Tooltip title="This is the data shown on hover">
                            <Button>Hover me</Button>
                        </Tooltip> */}
                    </Grid>

                </Grid>

                {(geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? (
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        justifyContent="space-between"
                    >
                        <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(45% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: (geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                        >
                            <Typography fontWeight="fontWeightBold" sx={[{ mb: 2 }, headerStyle]}>Problem formulation details</Typography>


                            <>
                                {geometryInputs.length > 0 && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <AirIcon sx={[card_icon, { color: "#008cff" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Geometry Inputs: </span>

                                        <span style={textStyle}> {geometryInputs.join(',  ')}</span>
                                    </Typography>
                                )}

                                {boundaryCondition && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <AnalyticsIcon sx={[card_icon, { color: "#e59128" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Boundary Condition: </span>

                                        <span style={textStyle}> {boundaryCondition}</span>
                                    </Typography>
                                )}

                                {outputVariables.length > 0 && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <CycloneIcon sx={[card_icon, { color: "#1daa07" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Variables: </span>

                                        <span style={textStyle}> {outputVariables.join(', ')}</span>
                                    </Typography>
                                )}
                            </>

                        </Card>

                        <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(55% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: ((inputConstraints && inputConstraints !== '[ ]') || (outputConstraints && outputConstraints !== '[ ]')) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                        >
                            <Typography sx={[headerStyle, { marginBottom: "8px" }]}>Constraints</Typography>


                            <>
                                {inputConstraints && inputConstraints !== '[ ]' && (
                                    <Typography sx={[subHeaderStyle,]}>
                                        <ArticleIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Input Constraints: </span>

                                        <span style={textStyle}> {inputConstraints}</span>
                                    </Typography>
                                )}

                                {outputConstraints && outputConstraints !== '[ ]' && (
                                    <Typography sx={subHeaderStyle}>
                                        <ArticleIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Constraints: </span>

                                        <span style={textStyle}> {outputConstraints}</span>
                                    </Typography>
                                )}
                            </>

                        </Card>
                    </Box>) : null}
            </Card>

            <Card variant="outlined" sx={cardStyle}>

                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                        fontWeight: "600",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                        fontSize: "18px",
                    }}
                >
                    Select variable to surrogate and model/kernel. Provide a name:
                </Typography>

                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                        fontWeight: "500",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                        fontSize: "15px",
                    }}
                >
                    <span style={{ color: '#888888', fontSize: 13 }}>When checked, evaluation will be performed based on geometries rather than individual data points</span><br></br>
                    <Checkbox checked={geometry} sx={{ padding: 0 }} onChange={e => setGeometry(!geometry)} />   <span style={{ verticalAlign: "sub" }}>Use Geometry-Based Evaluation</span>
                </Typography>



                <Grid container spacing={4} sx={{ mb: 3 }}>
                    <Grid size={3}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">
                                Select output variable
                            </InputLabel>
                            <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={selectoutputVariable}
                                label="Select output variable"
                                onChange={(e) => setSelectoutputVariable(e.target.value)}
                            >
                                {outputVariables.map((outputVariable) => {
                                    return (
                                        <MenuItem value={outputVariable}>{outputVariable}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={3}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">Select kernel</InputLabel>
                            {/* <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={selectKernel}
                                label="Select Kernel"
                                multiple
                                onChange={(e) => {
                                    if (e.target.value === 'Auto Kernel/Model Selection') {
                                        setErrorMetric('')
                                    }
                                    setSelectKernel(e.target.value)
                                }}
                            >
                                {kernelList.map((kernel) => {
                                    return <MenuItem value={kernel}>{kernel}</MenuItem>;
                                })}
                            </Select> */}

                            {/* <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                multiple
                                fullWidth
                                value={selectKernel}
                                label="Select Kernel"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectKernel(value);
                                }}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} />
                                        ))}
                                    </Box>
                                )}
                                sx={{ maxHeight: 'auto' }}
                            >
                                {kernelList.map((kernel) => (
                                    <MenuItem key={kernel} value={kernel}>
                                        {kernel}
                                    </MenuItem>
                                ))}
                            </Select> */}

                            <Select
                                label="problem-formulation"
                                id="demo-simple-select"
                                multiple
                                fullWidth
                                value={selectKernel}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectKernel(typeof value === 'string' ? value.split(',') : value);
                                }}
                                renderValue={renderValue}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: 'auto',
                                        },
                                    },
                                }}
                            >
                                {kernelList.map((kernel) => (
                                    <MenuItem
                                        key={kernel}
                                        value={kernel}
                                        style={{
                                            width: 'fit-content',
                                            minWidth: '150px',
                                        }}
                                    >
                                        <Checkbox checked={selectKernel.indexOf(kernel) > -1} />
                                        <ListItemText primary={kernel} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {
                        selectKernel.length > 1 &&
                        <Grid size={3}>
                            <FormControl fullWidth sx={{ mt: 2 }}>
                                <InputLabel id="problem-formulation">Select error metric</InputLabel>
                                <Select
                                    id="demo-simple-select"
                                    value={errorMetric}
                                    label="Select error metric"
                                    onChange={(e) => setErrorMetric(e.target.value)}
                                >
                                    {errorMetricList.map((kernel) => {
                                        return <MenuItem value={kernel}>{kernel}</MenuItem>;
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                    }


                    <Grid size={3}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <TextField
                                value={surrogateModelName}
                                onChange={(e) => {
                                    setSurrogateModelName(e.target.value)
                                    setUniqueName(`${problemFormulation}_${e.target.value}`)
                                }}
                                id="outlined-basic"
                                label="Surrogate model name"
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>

                    <Grid size={3}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <TextField
                                disabled
                                value={uniqueName}
                                id="outlined-basic"
                                label="Problem + Surrogate name"
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Button onClick={generateSurrogateParallel} disabled={!checkSurrogateButton} fullWidth sx={buttonStyle} variant="contained">Generate Surrogate</Button>

            </Card>



            {bestKernel && <Card variant="outlined" sx={cardStyle}>

                <Grid container spacing={1}>
                    <Grid size={12}>


                        <Typography
                            variant="h6"
                            gutterBottom
                            sx={{
                                fontWeight: "600",
                                color: "rgb(27 37 75)",
                                fontFamily: "DM Sans, sans-serif",
                                fontSize: "19px",
                            }}
                        >
                            {`Model training completed. Kernel used: "${bestKernelName} " `}
                        </Typography>
                    </Grid>
                </Grid>


            </Card>}

            {errorTable.length > 0 && <Card variant="outlined" sx={cardStyle}>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                        fontWeight: "600",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                        fontSize: "18px",
                    }}
                >
                    Results:
                </Typography>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                        fontWeight: "600",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                        fontSize: "16px",
                        marginBottom: '15px'
                    }}
                >
                    Training and testing error:
                </Typography>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell> <b>Dataset</b></TableCell>
                                <TableCell><b>MAPE (%)</b></TableCell>
                                <TableCell><b>RMSE (%)</b></TableCell>
                                <TableCell><b>RMSE</b></TableCell>
                                <TableCell><b>R2</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {errorTable?.map((row) => (
                                <TableRow key={row.Dataset}>
                                    <TableCell>{row["Dataset"]}</TableCell>
                                    <TableCell>{row["MAPE (%)"]}</TableCell>
                                    <TableCell>{row["RMSE (%)"]}</TableCell>
                                    <TableCell>{row['RMSE']}</TableCell>
                                    <TableCell>{row["R2"]}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </Card>}

            {bestKernel &&
                <Card variant="outlined" sx={cardStyle}>
                    <ModelRecommendations test_mape={testMape} test_r2={testR2} />
                </Card>
            }

            {Object.keys(graph1).length > 0 && <Card variant="outlined" sx={cardStyle}>

                <Grid container spacing={12} sx={{ mb: 8 }}>
                    <Grid size={6}>
                        {/* {graph1 ? <ScatterPlot data={graph1} title="Prediction vs Actual (Training Data)" label="Ws_W vs Pts_pa (Training Data)" /> : null} */}
                        <Plot
                            data={graph1?.data}
                            layout={graph1?.layout}
                            // config={{ responsive: true }}
                            style={{ width: '100%', height: '100%' }}
                        />

                    </Grid>
                    <Grid size={6}>
                        {/* <ScatterPlot data={graph2} title="Prediction vs Actual (Testing Data)" label="Ws_W vs Pts_pa (Testing Data)" /> */}
                        <Plot
                            data={graph3?.data}
                            layout={graph3?.layout}
                            // config={{ responsive: true }}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Grid>
                </Grid>


                <Grid container spacing={12} sx={{ mb: 8 }}>
                    <Grid size={6}>
                        {/* <ScatterPlotWithoutData data={graph3} title="Predicted vs Actual (Testing Data)" label="Ws_W Actual vs Predicted (Testing Data)" /> */}
                        <Plot
                            data={graph2?.data}
                            layout={graph2?.layout}
                            // config={{ responsive: true }}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Grid>
                    <Grid size={6}>
                        {/* <ErrorHistogram chartDataJson={graph4} /> */}
                        <Plot
                            data={graph4?.data}
                            layout={graph4?.layout}
                            // config={{ responsive: true }}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={12} sx={{ mb: 8 }}>

                    <Grid size={6}>
                        {/* <PerformancePlot chartDataJson={performancePlot1} /> */}
                        <Plot
                            data={performancePlot1?.data}
                            layout={performancePlot1?.layout}
                            // config={{ responsive: true }}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Grid>
                    <Grid size={6}>
                        {/* <PerformancePlot chartDataJson={performancePlot2} /> */}
                        <Plot
                            data={performancePlot2?.data}
                            layout={performancePlot2?.layout}
                            // config={{ responsive: true }}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Grid>
                </Grid>

            </Card>}

            {bestKernel && <Card variant="outlined" sx={{ ...cardStyle }}>
                {finalTrialCompleted && <Typography
                    variant="h8"
                    gutterBottom
                    sx={{
                        fontWeight: "600",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                        fontSize: "20px",
                        display: "flex",
                        justifyContent: "end"

                    }}
                >
                    Model '{problemFormulation}' for '{selectoutputVariable}' saved successfully!
                </Typography>}
                <Grid container spacing={12} sx={{ mb: 3 }}>

                    <Grid size={6}>
                        <Button onClick={downloadSurrogateFile} fullWidth sx={buttonStyle} variant="contained">Download Results Excel</Button>
                    </Grid>

                    <Grid size={6}>
                        <Button onClick={trainFinalSurrogateModel} fullWidth sx={buttonStyle} variant="contained">Train Final Model and Save</Button>
                    </Grid>
                </Grid>
            </Card>}


            <Card variant="outlined" sx={cardStyle}>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                        fontWeight: "600",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                        fontSize: "18px",
                    }}
                >
                    Adaptive Sampling {bestKernel && <Tooltip title="Before proceeding, execute the Trial Final Model and Save to generate adaptive samples" onClick={() => { setopenInfoAlert(true) }}><HelpRoundedIcon sx={{ verticalAlign: "middle", marginLeft: "5px", fontSize: "22px" }} /></ Tooltip>}
                </Typography>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                        fontWeight: "600",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                        fontSize: "16px",
                        marginBottom: '15px'
                    }}
                >
                    Generate samples to improve model accuracy in regions with high uncertainty
                </Typography>

                <Grid container spacing={2} sx={{
                    mb: 3, justifyContent: "center",
                    alignItems: "center",
                }}>
                    <Grid size={4}>
                        <FormControl fullWidth sx={{ mt: 2, padding: 0 }}>
                            <InputLabel id="select-surrogate-label">Select surrogate model</InputLabel>
                            <Select
                                labelId="select-surrogate-label"
                                id="select-surrogate-label"
                                multiple={false}
                                value={selectedModel}
                                onChange={handleModelChange}
                                input={<OutlinedInput label="Select surrogate model" />}

                            >
                                {targetModels?.map((item) => (
                                    <MenuItem key={item} value={item} >
                                        <ListItemText primary={item} />
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            fullWidth
                            sx={{ mt: 2 }}
                            label="Number of Sample Collected"
                            type="number"
                            value={surrogateNumber}
                            onChange={(e) => setSurrogateNumber(e.target.value)}
                        />
                    </Grid>
                    <Grid size={4}>
                        <Button disabled={!surrogateNumber || !selectedModel} onClick={generate_adaptive_sampling} fullWidth sx={{ ...buttonStyle, mt: 2, height: '53px' }} variant="contained">Generate Samples</Button>
                    </Grid>
                </Grid>

            </Card>

            <Dialog
                open={openInfoAlert}
                onClose={closeDialog}
                aria-labelledby="model-alert-dialog-title"
                aria-describedby="model-alert-dialog-description"
            >
                <DialogTitle id="model-alert-dialog-title">
                    {"Generate Samples for the Current Surrogate Model"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="model-alert-dialog-description">
                        Before proceeding, execute the Trial Final Model and Save to generate adaptive samples for <b>{uniqueName}</b>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog}>Cancel</Button>

                </DialogActions>
            </Dialog>



            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loadopen}
            >
                <CircularProgress size="4rem" />
            </Backdrop>

            <CustomizedSnackbar action={snackbarOpen} message={snackbarMsg} severityType={severityType} />

            <ModelGenerationProgressModal
                progress={progressBarValue} // 0-100
                message={progressBarMsg} // dynamic from backend
                status={progressBarStatus} // "IN_PROGRESS" | "COMPLETED" | "FAILED"
            />


        </>
    );
};
